export type WorkspaceSystemField = Diagonal.Workspaces.Enums.DefaultWorkspaceSystemField;

type WorkspaceSystemFieldValue = string | number | boolean | null;

export type WorkspaceValues =
  | (Partial<Record<WorkspaceSystemField, WorkspaceSystemFieldValue>> & Record<string, unknown>)
  | null;

export function getWorkspaceSystemString(
  workspace: { values?: WorkspaceValues } | null | undefined,
  field: WorkspaceSystemField
): string | null | undefined {
  const value = getWorkspaceSystemValue(workspace, field);

  return typeof value === 'string' || value === null ? value : undefined;
}

export function getWorkspaceSystemValue<TField extends WorkspaceSystemField>(
  workspace: { values?: WorkspaceValues } | null | undefined,
  field: TField
): WorkspaceSystemFieldValue | undefined {
  const value = workspace?.values?.[field];

  if (value === null) {
    return value;
  }

  const type = typeof value;
  return type === 'string' || type === 'number' || type === 'boolean' ? value : undefined;
}
